export default "__VITE_ASSET__BOy8rjqN__"